import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class INDRAParallelService {

    private _triggerCreatePassenger = new BehaviorSubject<boolean>(false);
    private _triggerCreateContact = new BehaviorSubject<boolean>(false);
    private _resetValuesCompleted = new BehaviorSubject<boolean>(false);
    private _isPassengerCreated = new BehaviorSubject<boolean>(false);
    private _isContactCreated = new BehaviorSubject<boolean>(false);
    private _areCheckboxesCompleted = new BehaviorSubject<boolean>(false);
    private _isGenerateApiLoading = new BehaviorSubject<boolean>(false);
    private _isCatalogueApiLoading = new BehaviorSubject<boolean>(false);
    private _isPaymentMethodLoading = new BehaviorSubject<boolean>(false);

    triggerCreatePassenger$ = this._triggerCreatePassenger.asObservable();
    triggerCreateContact$ = this._triggerCreateContact.asObservable();
    resetValuesCompleted$ = this._resetValuesCompleted.asObservable();
    isPassengerCreated$ = this._isPassengerCreated.asObservable();
    isContactCreated$ = this._isContactCreated.asObservable();
    areCheckboxesCompleted$ = this._areCheckboxesCompleted.asObservable();
    isGenerateApiLoading$ = this._isGenerateApiLoading.asObservable();
    isCatalogueApiLoading$ = this._isCatalogueApiLoading.asObservable();
    isPaymentMethodLoading$ = this._isPaymentMethodLoading.asObservable();

	constructor() {

	}

    INDRA_setTriggerCreatePassenger(value: boolean) {
        this._triggerCreatePassenger.next(value);
    }

    INDRA_setTriggerCreateContact(value: boolean) {
        this._triggerCreateContact.next(value);
    }

    INDRA_setResetValuesCompleted(value: boolean) {
        this._resetValuesCompleted.next(value);
    }

    INDRA_setIsPassengerCreated(value: boolean) {
        this._isPassengerCreated.next(value);
    }

    INDRA_setIsContactCreated(value: boolean) {
        this._isContactCreated.next(value);
    }

    INDRA_setAreCheckboxesCompleted(value: boolean) {
        this._areCheckboxesCompleted.next(value);
    }

    INDRA_setIsGenerateApiLoading(value: boolean) {
        this._isGenerateApiLoading.next(value);
    }

    INDRA_setIsCatalogueApiLoading(value: boolean) {
        this._isCatalogueApiLoading.next(value);
    }

    INDRA_setIsPaymentMethodLoading(value: boolean) {
        this._isPaymentMethodLoading.next(value);
    }

    get isGenerateApiLoading(): boolean {
        return this._isGenerateApiLoading.getValue();
    }

    get isCatalogueApiLoading(): boolean {
        return this._isCatalogueApiLoading.getValue();
    }

    get isPaymentMethodLoading(): boolean {
        return this._isPaymentMethodLoading.getValue();
    }

    INDRA_reset(): void {
      this.INDRA_setIsPassengerCreated(false);
      this.INDRA_setIsContactCreated(false);
      this.INDRA_setAreCheckboxesCompleted(false);
    }
}
